const MAX_BYTES = Math.floor(3.75 * 1024 * 1024); // 3,932,160
const EDGES = [1568, 1280, 1024, 800];
const START_Q = 0.85;
const MIN_Q = 0.4;
 
/** Returns "data:image/jpeg;base64,..." or null, like MeterImageEncoder.dataURI(from:). */
export async function meterImageDataURI(file) {           // file: a File/Blob from <input type="file">
  let bitmap;
  try {
    // 'from-image' applies the photo's rotation flag, like fixedOrientation()
    bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
  } catch {
    return null;                                     // couldn't decode the image
  }
  try {
    for (const edge of EDGES) {
      const canvas = drawResized(bitmap, edge);
      for (let q = START_Q; q >= MIN_Q; q -= 0.1) {
        const blob = await toJpegBlob(canvas, q);
        if (blob && blob.size <= MAX_BYTES) 
          return blobToDataURI(blob);
      }
    }
    // Last resort: smallest size, lowest quality
    const blob = await toJpegBlob(drawResized(bitmap, 800), MIN_Q);
    return blob ? blobToDataURI(blob) : null;
  } finally {
    bitmap.close();
  }
}
 
/** Scales so the long edge is <= longEdge (never scales up), like resized(longEdge:). */
function drawResized(bitmap, longEdge) {
  const scale = Math.min(1, longEdge / Math.max(bitmap.width, bitmap.height));
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(bitmap.width * scale);
  canvas.height = Math.round(bitmap.height * scale);
  canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  return canvas;
}
 
const toJpegBlob = (canvas, quality) =>
  new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', quality));
 
const blobToDataURI = blob =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);  // "data:image/jpeg;base64,..."
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
